import Environment from 'utils/Environment';
import * as Sentry from '@sentry/react';

const environment = Environment.getVar('REACT_APP_ENV') ?? 'production';
const ipWhoisApiKey = Environment.getVar('REACT_APP_IPCONFIG_KEY') ?? 'production';

const DEV_ENDPOINT = 'https://ipwho.is';
const PROD_ENDPOINT = `https://ipwhois.pro/?key=${ipWhoisApiKey}`;

type Flag = {
  img: string;
  emoji: string;
  emoji_unicode: string;
};

type Connection = {
  asn: number;
  org: string;
  isp: string;
  domain: string;
};

type Timezone = {
  id: string;
  abbr: string;
  is_dst: boolean;
  offset: number;
  utc: string;
  current_time: string;
};

type Currency = {
  name: string;
  code: string;
  symbol: string;
  plural: string;
  exchange_rate: number;
};

type Security = {
  anonymous: boolean;
  proxy: boolean;
  vpn: boolean;
  tor: boolean;
  hosting: boolean;
};

type GeoInfo = {
  ip: string;
  success: boolean;
  type: string;
  continent: string;
  continent_code: string;
  country: string;
  country_code: string;
  region: string;
  region_code: string;
  city: string;
  latitude: number;
  longitude: number;
  is_eu: boolean;
  postal: string;
  calling_code: string;
  capital: string;
  borders: string;
  flag: Flag;
  connection: Connection;
  timezone: Timezone;
  currency: Currency;
  security: Security;
};

export const getGeoLocation = async (): Promise<GeoInfo | undefined> => {
  let geo: GeoInfo | undefined;
  const endpoint = environment === 'production' ? PROD_ENDPOINT : DEV_ENDPOINT;
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);
    const response = await fetch(endpoint, {signal: controller.signal});
    clearTimeout(timeoutId);

    if (!response.ok) {
      throw new Error(`Geo endpoint responded with status ${response.status}`);
    }

    const parsed = (await response.json()) as Partial<GeoInfo>;

    // Basic shape validation to avoid propagating malformed data
    if (
      typeof parsed === 'object' &&
      parsed !== null &&
      typeof parsed.country_code === 'string' &&
      typeof parsed.region_code === 'string'
    ) {
      geo = parsed as GeoInfo;
    } else {
      // Return undefined if required fields are missing
      geo = undefined;
    }
  } catch (e) {
    Sentry.captureException(e);
  }
  console.log('geo', geo);
  return geo;
};
